<template>
  <div class="table-page-search-wrapper">
    <a-form layout="inline">
      <a-form layout="inline">
        <a-row :gutter="48"> <a-col :md="6" :sm="24">
          <a-form-item label="进展情况">
            <a-input placeholder="请输入进展情况" v-model="searchModel.info"/>
          </a-form-item>
        </a-col><a-col :md="6" :sm="24">
          <a-form-item label="需要协调信息">
            <a-input placeholder="请输入需要协调信息" v-model="searchModel.remark"/>
          </a-form-item>
        </a-col><a-col :md="6" :sm="24">
          <a-form-item label="联系人">
            <a-select v-model="searchModel.contactId" :allowClear="true" >
              <a-select-option v-for="(item,index) in contactList" :key="index">
                {{ item.label }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col><template v-if="advanced"><a-col :md="6" :sm="24">
          <a-form-item label="跟踪人">
            <a-input placeholder="请输入跟踪人" v-model="searchModel.trackerId"/>
          </a-form-item>
        </a-col><a-col :md="6" :sm="24">
          <a-form-item label="跟踪时间">
            <a-input placeholder="请输入跟踪时间" v-model="searchModel.traceTime"/>
          </a-form-item>
        </a-col><a-col :md="6" :sm="24">
          <a-form-item label="跟进状态">
            <a-input placeholder="请输入跟进状态" v-model="searchModel.status"/>
          </a-form-item>
        </a-col></template><a-col :md="6" :sm="24">
          <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
            <a-button type="primary" @click="search">查询</a-button>
            <a-button style="margin-left: 8px" @click="clearSearch">重置</a-button>
            <a @click="toggleAdvanced" style="margin-left: 8px" v-if="true" v-show="showExpend">
              {{ advanced ? '收起' : '展开' }}
              <a-icon :type="advanced ? 'up' : 'down'" v-if="true" v-show="showExpend"/></a>
          </span>
        </a-col>
        </a-row>
      </a-form>
    </a-form>
  </div>
</template>

<script>
// import { getSelectContactList } from '@/api/follows'

export default {
  name: 'FollowsSearchForm',
  mounted () {
    // this.getSelectContactList()
  },
  data () {
    return {
      showExpend: false,
      contactList: [],

      searchModel: {
      },
      advanced: false// 是否展开
    }
  },
  methods: {
    // 搜索框展开
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    // 点击查询按钮
    search () {
      this.$emit('setSearchCondition', this.searchModel)
    },
    // 点击复位按钮
    clearSearch () {
      this.searchModel.info = ''
      this.searchModel.remark = ''
      this.searchModel.contactId = ''
      this.searchModel.trackerId = ''
      this.searchModel.traceTime = ''
      this.searchModel.status = ''

      this.$emit('clearSearch', this.searchModel)
    }
    // 获取select列表
    // getSelectContactList () {
    //   getSelectContactList().then(res => {
    //     if (res.status === 0) {
    //       this.contactList = res.data.list
    //     }
    //   })
    // }
  }
}
</script>

<style scoped>

</style>
